<div
    class="agpr-dateQueryInput u-mdPadding ui-inputgroup"
    [ngClass]="{
        'agpr-dateQueryInput--socialPlus': style === agprComponentStyle.socialPlus
    }"
>
    <span
        class="fa-duotone fa-regular fa-calendar-range"
        aria-hidden="true"
    ></span>
    <span
        [id]="id + '_dateLabel'"
        class="u-srOnly"
    >
        {{ 'dateRangeSelection' | localize }}
    </span>

    @if (isCustomDateRange) {
        <agpr-date-picker
            #calendar
            [id]="id + '_datePicker'"
            class="agpr-dateQueryInput-datePicker"
            selectionMode="range"
            [showIcon]="false"
            [minDate]="minimumCustomDate"
            [maxDate]="maximumCustomDate"
            [ariaLabelledBy]="id + '_dateLabel'"
            [hideFormatHint]="hideFormatHint"
            [(ngModel)]="calendarValue"
            (close)="calendarClosed($event)"
        ></agpr-date-picker>
    } @else {
        <agpr-text-input
            #displayInput
            type="text"
            [id]="'dateQueryInput_value'"
            [ngModel]="displayValue | localize"
            ariaLabel="date"
            [placeholder]="inputPlaceholder | localize"
            [icon]="icon"
            [iconPopoverTemplate]="iconPopoverTemplate"
            [iconPopoverStyleClass]="iconPopoverStyleClass"
            [readonly]="true"
            [bottomMargin]="false"
            [style]="style"
        ></agpr-text-input>
    }

    <agpr-icon-dropdown
        #dropdown
        class="agpr-dateQueryInput-dropdown"
        [id]="id + '_dateQuery_dropdown'"
        (change)="dropdownSelected($event)"
        [(ngModel)]="dropdownValue"
        [options]="options"
        [pTooltip]="toolTipLabel | localize"
        [tooltipDisabled]="!toolTipLabel"
        tooltipPosition="top"
        [agprStyle]="agprComponentStyle.social"
    ></agpr-icon-dropdown>
</div>

